export function getDefaultCard(cards) {
  return (cards?.length && cards.find(card => card?.default)) || null;
}

export function getDefaultUserCard(cards, returnNotDefault = false) {
  const userCards = cards.filter(card => card.type === 'card');

  return (
    (cards?.length && cards.find(card => card?.default)) ||
    (returnNotDefault && userCards[userCards.length - 1]) ||
    null
  );
}

export default { getDefaultCard, getDefaultUserCard };
